import { Box, IconButton, useBreakpointValue } from '@chakra-ui/react';
import NavigationMenu from './NavigationMenu';
import { useState } from 'react';
import { FaBars } from 'react-icons/fa';
import UserFooter from './UserFooter';
import { ChatWindow } from '../features/chat';
import AcceptTerms from './AcceptTerms';
import { useUser } from '../hooks/useUser';
import { useUserStore } from '../store/userStore';
import TopNav from './TopNav';

interface AuthenticatedLayoutProps {
  children: React.ReactNode;
}

const AuthenticatedLayout = ({ children }: AuthenticatedLayoutProps) => {
  const [isMenuCollapsed, setIsMenuCollapsed] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const isMobile = useBreakpointValue({ base: true, md: false }) ?? false;

  useUser(); // still call to ensure user data is loaded, but don't destructure unused values
  const { user } = useUserStore();

  return (
    <Box
      minHeight="100vh"
      w="100%"
      position="absolute"
      top="0"
      left="0"
      color="white"
      fontFamily="'Exo 2', sans-serif"
      display="flex"
      flexDirection="column"
      px={{ base: '2px', md: '4px' }}
      py="0"
      sx={{
        background: `
          linear-gradient(165deg, 
            black 0%, 
            #002e0b 80vh,
            #002e0b 100%
          )
        `,
      }}
    >
      <NavigationMenu
        onCollapse={setIsMenuCollapsed}
        isMobileMenuOpen={isMobileMenuOpen}
        onMobileMenuToggle={setIsMobileMenuOpen}
      />
      {isMobile && !isMobileMenuOpen && (
        <IconButton
          aria-label="Open navigation menu"
          icon={<FaBars />}
          position="fixed"
          top="12px"
          left="12px"
          zIndex={1100}
          color="white"
          variant="ghost"
          borderRadius="md"
          bg="blackAlpha.500"
          _hover={{ bg: 'whiteAlpha.200' }}
          _focus={{ boxShadow: 'none' }}
          onClick={() => setIsMobileMenuOpen(true)}
        />
      )}
      <TopNav />
      <Box
        ml={{ base: 0, md: isMenuCollapsed ? '60px' : '200px' }}
        transition="margin-left 0.3s"
        p={{ base: 0, md: 4 }}
        flex="1 1 auto"
        display="flex"
        flexDirection="column"
      >
        <Box flex="1 1 auto" p={0} px={{ base: '2px', md: '4px' }} display="flex" flexDirection="column">
          <AcceptTerms />
          <Box flex="1 1 auto" p={0}>
            {children}
          </Box>
          <UserFooter />
        </Box>
      </Box>
      {user?.terms_accepted && <ChatWindow />}
    </Box>
  );
};

export default AuthenticatedLayout; 